import React, { useEffect, useState } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import { MdEdit } from 'react-icons/md'
import { TiDeleteOutline } from 'react-icons/ti'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { Link } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useNavigate } from 'react-router-dom'

export const UserList = () => {
  toast.configure()
  const [data, setData] = useState()

  const [total, setTotal] = useState()
  const [id, setId] = useState('')
  const [users, setUsers] = useState([])

  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  const token = localStorage.getItem('token')

  const getUsers = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchUsers', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setUsers(res.data.data)
      })
      .catch((err) => {})
  }

  // get all user (Admin/HR/Interviewer)
  const getData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'filter/fetchUsersBasedOnRole',
        { id: ' ' },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        setData(res.data.userData)

        setTotal(res.data.totalUsers)
      })
      .catch((err) => {
        if (err.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  // fetch candidates based on role(on dropdown selection)
  const onSubmit = async (i) => {
    await axios
      .post(
        Baseurl.nodeLocal + 'filter/fetchUsersBasedOnRole',
        { id: i },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        setData(res.data.userData)
        setTotal(res.data.totalUsers)
      })
      .catch((err) => {
        if (err.response.status === 401) {
          logout()
        }
      })
  }
  useEffect(() => {
    getUsers()
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // columns to display data in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,

      width: '80px',
    },
    {
      name: 'Name',
      cell: (cell) => {
        return (
          <Tippy content={cell.name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {' '}
              {cell.name}
            </p>
          </Tippy>
        )
      },
      sortable: true,
      width: '200px',
    },

    {
      name: 'Email',
      cell: (row) => {
        return (
          <Tippy content={row.email} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.email}
            </p>
          </Tippy>
        )
      },
      sortable: true,
      width: '250px',
    },
    {
      name: 'Role',
      selector: (row) => row.role,
      sortable: true,
      width: '200px',
    },
    {
      name: 'Contact',
      selector: (row) => row.contact,
      sortable: true,
      width: '220px',
    },
    {
      name: 'Action',
      cell: (row) => (
        <>
          <Link to={'/editUser/' + row.uuid} className="link">
            <MdEdit className="editbtn" />
          </Link>
          <TiDeleteOutline
            className="deletebtn"
            data-bs-target="#deleteUserModal"
            data-bs-toggle="modal"
            onClick={() => setId(row.uuid)}
          />
        </>
      ),
      width: '140px',
    },
  ]

  // delete user
  const deleteData = async (id) => {
    await axios
      .post(
        Baseurl.nodeLocal + 'enduser/deleteUser',
        {
          id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        if (error.response.status === 401) {
          logout()
        }
      })
  }

  return (
    <>
      <Sidebar />

      <div className="container userList mt-5">
        <div className=" mt-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/home" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Users
              </li>
            </ol>
          </nav>
        </div>
        <div className="row d-flex justify-content-between mb-4">
          <div className="col-md">
            <h5 className="text-primary">Users</h5>
          </div>

          <div
            className="col-md d-flex justify-content-end"
            style={{ marginRight: '1rem' }}
          >
            <Link to="/register" className="link">
              <button className="btn btn-primary">Add New User</button>
            </Link>
          </div>
        </div>

        <DataTable
          columns={columns}
          data={data}
          pagination
          highlightOnHover
          subHeader
          subHeaderComponent={
            <div className="mt-5" style={{ width: '20%' }}>
              <div className="col-md">
                <h6>Total Users : {total}</h6>
              </div>
              <div className="col-md form-floating">
                <select
                  className="form-select"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  name="role"
                  //value={role}
                  onChange={(e) => onSubmit(e.target.value)}
                >
                  <option disabled selected value="">
                    Select
                  </option>

                  {users?.map((i, index) => {
                    if (i.name !== 'Candidates') {
                      return (
                        <option value={i.id} key={index}>
                          {i.name}
                        </option>
                      )
                    } else {
                      return null
                    }
                  })}
                </select>
                <label for="floatingSelect">Select Users</label>
              </div>
            </div>
          }
        />
        {/* confirmation modal to delete data */}
        <div
          className="modal"
          tabIndex="-1"
          id="deleteUserModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Alert</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete the data ?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    deleteData(id)
                  }}
                  data-bs-dismiss="modal"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
